<script>
    export let progress = null

    let bars

    const infer_state = p => {
        switch (p?.mode) {
            case 'download':
                return {
                    download: p.progress * 100,
                    keyderive: null,
                    aes: null,
                    hash: null
                }
            case 'keyderive':
                return {
                    download: 100,
                    keyderive: p.progress * 100,
                    aes: null,
                    hash: null
                }
            case 'aes':
                return {
                    download: 100,
                    keyderive: 100,
                    aes: p.progress * 100,
                    hash: null
                }
            case 'hash':
                return {
                    download: 100,
                    keyderive: 100,
                    aes: 100,
                    hash: p.progress * 100,
                }
            default:
                return bars
        }
    }

    $: bars = infer_state(progress)

</script>

{#if progress}

{#if progress?.msg}
    <div class="notification is-danger block">
        {progress.msg}
    </div>
{/if}

<div class="progress_bars box block">
    <div class="field">
        <label for="progress_download">Download</label>
        <progress
            class="progress is-link"
            id="progress_download"
            value={bars.download}
            max="100">
            {bars.upload}%
        </progress>
    </div>
    <div class="field">
        <label for="progress_keyderive">Key derivation</label>
        <progress 
            class="progress is-link"
            id="progress_keyderive"
            value={bars.keyderive}
            max="100">
            {bars.keyderive}%
        </progress>
    </div>
    <div class="field">
        <label for="progress_aes">AES decryption</label>
        <progress
            class="progress is-link"
            id="progress_aes"
            value={bars.aes}
            max="100">
            {bars.aes}%
        </progress>
    </div>
    <div class="field">
        <label for="progress_hash">Hash check</label>
        <progress
            class="progress is-link"
            id="progress_hash"
            value={bars.hash}
            max="100">
            {bars.aes}%
        </progress>
    </div>
</div>

{/if}

<style>
    
</style>

